import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ConsentTypeDef, resolveConsentType } from '../consent-types';

@Component({
    selector: 'app-print-usg-consent',
    templateUrl: './print-usg-consent.component.html',
    styleUrls: ['./print-usg-consent.component.scss'],
    standalone: false
})
export class PrintUsgConsentComponent implements OnInit {
  autoIndex: string;
  concentForm: FormGroup;
  env: any = null;
  altHeader: SafeHtml = null;

  constructor(
    private route: ActivatedRoute,
    public http: HttpClient,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.autoIndex = this.route.snapshot.params['autoIndex'];
    const code = this.route.snapshot.params['code'];
    this.resetForm();

    // Puppeteer opens this page without a session; the one-shot code restores the
    // clinic identity so /api/getenv and /api/logo resolve.
    if (code) {
      this.http.post('/api/consent/resurection', { code }).subscribe(
        () => { this.loadHeader(); this.loadData(); },
        () => { this.loadHeader(); this.loadData(); }
      );
    } else {
      this.loadHeader();
      this.loadData();
    }
  }

  loadHeader() {
    this.http.get<any>('/api/getenv').subscribe(
      (envData) => {
        this.env = envData;
        if (envData && envData['htmlheader']) {
          this.altHeader = this.sanitizer.bypassSecurityTrustHtml(envData['htmlheader']);
        }
        this.changeDetector.detectChanges();
      },
      () => {}
    );
  }

  resetForm() {
    this.concentForm = this.fb.group({
      AutoIndex: [''], PID: [''], UID: [''], GID: [''],
      ExamID: [''], AWLID: [''], Opener: [''],
      First: [''], Last: [''], ID: [''], Phone: [''],
      CreationTime: [''], refferalDoc: [''],
      ConsentType: [''],
      patSign: [''], docSign: [''],
      printed: [''],
    });
  }

  loadData() {
    this.http.get<any>(`/api/consent/usg/${this.autoIndex}`).subscribe((data) => {
      if (!data) return;
      this.concentForm.patchValue(data);
      if (data.CreationTime) {
        const d = new Date(data.CreationTime);
        const pad = (n: number) => n.toString().padStart(2, '0');
        this.concentForm.get('CreationTime').setValue(
          `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
          `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        );
      }
      this.changeDetector.detectChanges();
    });
  }

  get consentDef(): ConsentTypeDef {
    return resolveConsentType(this.concentForm?.get('ConsentType')?.value);
  }
}
